import * as React from "react";
import GridMultipleFiles from "./GridMultipleFiles";

export const File = ({ api, dispatcher, column, value, handleChange }) => (
	<GridMultipleFiles
		api={api}
		dispatcher={dispatcher}
		ref={(node) => node}
		field={column}
		row={value}
		defaultValue={value || null}
		onSave={handleChange}
		isEditable={true}
		file_formats={column?.format || column?.extra?.file_formats || []}
	/>
);
